import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Mail } from 'lucide-react';

const OptionalFields = ({ 
  pastNewsletterSample,
  onPastNewsletterSampleChange,
  className = '' 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className={`space-y-4 ${className}`}>
      {/* Expandable Newsletter Sample */}
      <div className="border border-gray-200 rounded-lg">
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="w-full px-4 py-3 flex items-center justify-between text-left hover:bg-gray-50 transition-colors duration-200"
        >
          <div className="flex items-center space-x-2">
            <Mail className="w-4 h-4 text-yellow-600" />
            <span className="text-sm font-medium text-yellow-700">
              Voice Calibration
            </span>
          </div>
          {isExpanded ? (
            <ChevronUp className="w-4 h-4 text-yellow-600" />
          ) : (
            <ChevronDown className="w-4 h-4 text-yellow-600" />
          )}
        </button>

        {isExpanded && (
          <div className="px-4 pb-4">
            <label htmlFor="newsletterSample" className="block text-sm font-medium text-gray-700 mb-2">
              Paste a newsletter you've written before
            </label>
            <textarea
              id="newsletterSample"
              value={pastNewsletterSample}
              onChange={(e) => onPastNewsletterSampleChange(e.target.value)}
              placeholder="We'll match your tone and language..."
              className="textarea-field min-h-[100px]"
              rows={4}
            />
            <p className="mt-1 text-xs text-gray-500">
              This helps us match your writing voice and style
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default OptionalFields; 